/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";

const Containers = function (containerId) {


    async function create(containerName, imageIndexKey, exposedPorts, httpPort, nodeId) {


    }


    async function remove() {
        return callWSFunction("container.remove", {
            containerId: containerId
        })
    }

    async function getInfo() {
        return callWSFunction("container.getInfo", {
            containerId: containerId
        })
    }

    async function doesExist() {

    }

    async function listAll() {
        return callWSFunction("container.listAll", {})
    }

    function getLogs() {

    }

    function update(values) {
        return callWSFunction("container.update", {
            containerId: containerId,
            values: values
        })
    }

    function action(actionName) {
        return callWSFunction("container.action", {
            containerId: containerId,
            actionName: actionName
        })
    }


    return {create, remove, getInfo, getLogs, doesExist, listAll, update, action}
}

export {Containers}